var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPickup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 0.166687C7.77465 0.166687 5.40068 1.15002 3.65034 2.90036C1.9 4.6507 0.916672 7.02467 0.916672 9.50002C0.916672 16.5 10.25 26.8334 10.25 26.8334C10.25 26.8334 19.5833 16.5 19.5833 9.50002C19.5833 7.02467 18.6 4.6507 16.8497 2.90036C15.0993 1.15002 12.7254 0.166687 10.25 0.166687ZM16.25 9.50002H12.9167V16.1667H7.58334V9.50002H4.25L10.25 3.50002L16.25 9.50002Z",
    fill: "#008A80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.c6f0d45ae5024077aaf8eac78a8e2209.svg";
export { ForwardRef as ReactComponent };